module.exports = __webpack_public_path__ + "static/media/learning-guide.ecabaf32.svg";